import { EventTypeId } from '@ps/web-sports-enums';

export const landingPageEventTypeIds = [
  EventTypeId.SOCCER,
  EventTypeId.TENNIS,
  EventTypeId.BASKETBALL,
  EventTypeId.AMERICAN_FOOTBALL,
  EventTypeId.BASEBALL,
  EventTypeId.ICE_HOCKEY,
  EventTypeId.MIXED_MARTIAL_ARTS,
  EventTypeId.BOXING
] as const;
export type LandingPageEventTypeId = (typeof landingPageEventTypeIds)[number];
